import React from 'react';
import SectionHeader from '../components/SectionHeader';

export default function SolutionArchitect() {
  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="card" style={{ marginBottom: '2rem' }}>
          <div className="card-header">
            <h4>Scott Mason — Solution Architect</h4>
          </div>
          <div className="card-body">
            <p>Scott has designed and built Architectures that include:</p>
            <br />
            <ul>
              <li>
                <a href="#azure-cosmos">Cosmos DB sites</a> that provide user personalized offers and recommendations
              </li>
              <li>Azure Synapse solutions</li>
              <li>Databricks solutions</li>
              <li>Machine Learning solutions</li>
            </ul>
          </div>
        </div>

        {/* Azure Cosmos Design */}
        <div id="azure-cosmos" style={{ marginBottom: '2rem' }}>
          <SectionHeader title="Azure Cosmos Design — Predict Patient Length of Stay and Flow" />

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', alignItems: 'start' }}>
            <div className="info-block">
              <p>This solution helps the Marketing Department use the power of AI and Data Science to predict the value of any group of customers to the company, to improve marketing planning and spend. A chief marketing executive might use these predictive models to determine which customers are future high-value customers versus occasional customers.</p>
              <br />
              <p>The Sales Department might offer potential high-value customers better customer care or special incentives to build a better customer relationship.</p>
              <br />
              <p>And the customer receives a superior customer experience that better meets their needs.</p>
            </div>
            <div>
              <img
                alt="Azure Cosmos Design"
                src="/images/projects/azure-cosmos-design.jpg"
                style={{ width: '100%', borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.12)' }}
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          </div>
        </div>

        <div className="info-block">
          <p>Some of the technologies that Scott works with as a <u>developer</u> are outlined throughout this portfolio site.</p>
        </div>
      </div>
    </div>
  );
}
